<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m16 9v10h-8v-10zm-1.5-6h-5l-1 1h-3.5v2h14v-2h-3.5zm3.5 4h-12v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2z"
    />
  </svg>
</template>
